import type {PS} from '@wix/document-services-types'
import platform from '../platform/platform'
import {_tempGetAppAppDef} from '../wixCode/utils/tempGetAppDefId'
import clientSpecMap from '../siteMetadata/clientSpecMap'
import hooks from '../hooks/hooks'

export const CMS_APP_DEF_ID = 'e593b0bd-b783-45b8-97c2-873d42aacaf4'
const DATA_BINDING = 'dataBinding'

const conductDataBindingExperiments = async (ps: PS) => {
    try {
        const installedAppsExperiments = await ps.extensionAPI.platform.conductPlatformExperiments()
        ps.logger?.info?.('dataBinding experiments conducted', {
            experiments: installedAppsExperiments,
            scopes: ['viewer-apps-dataBinding']
        })
    } catch (error: any) {
        ps.logger?.error?.('Failed to conduct dataBinding experiments', {
            error: error?.message || String(error),
            scopes: ['viewer-apps-dataBinding']
        })
    }
}

const loadDataBinding = (ps: PS) => {
    if (clientSpecMap.hasCSMEntry(ps, DATA_BINDING)) {
        return
    }

    platform.initApp(ps, _tempGetAppAppDef(ps, 'dbsm-viewer-app', 'dbsm-editor-app', DATA_BINDING, true))
    conductDataBindingExperiments(ps)
}

const isCmsInstalled = (ps: PS) => clientSpecMap.hasCSMEntry(ps, CMS_APP_DEF_ID)

export default {
    initialize: (ps: PS) => {
        const {
            runtimeConfig: {supportsPlatformInitialization}
        } = ps

        if (!supportsPlatformInitialization) {
            return
        }

        if (isCmsInstalled(ps)) {
            loadDataBinding(ps)
        } else {
            hooks.registerHook(hooks.HOOKS.PLATFORM.APP_PROVISIONED, () => {
                if (isCmsInstalled(ps)) {
                    loadDataBinding(ps)
                }
            })
        }
    },
    loadDataBinding
}
